import routes from 'app/expert-invite/routes';

export default {
  routes,
};
